// What a side is called.
//
// **Its own module because the pure model needs it too.** It lived in the
// dock's component, which is fine for a component importing a component and
// wrong the moment `pieceBadges.ts` — deliberately the pure model behind
// `PieceOverlays` — wants to name the army a piece is disguised as. Importing
// a `.tsx` there would pull MUI into a file that has no business rendering
// anything.

import type { Color } from "src/engine/rules/board";

/** White, Black, and then whatever the waves have sent. */
export const armyName = (side: Color): string =>
  side === 0 ? "White" : side === 1 ? "Black" : `Army ${side + 1}`;

/**
 * Army colours for the watching readouts, echoing the pieces on the board.
 *
 * A short cycle rather than a lookup into the renderer: `PALETTE` names the
 * two classic sides and nothing else, and a run cycles through up to eight —
 * so a wave under a flag the palette has never heard of still needs a swatch.
 *
 * Here rather than in a component for `armyName`'s own reason: the watching
 * row is drawn beside the stock pill now, and the dying dock draws it too
 * until U8-C deletes that file.
 */
const ARMY_TONE = [
  "#f4edd9",
  "#a8c3ce",
  "#d1b566",
  "#98bdcb",
  "#e8b09a",
  "#afcbd6",
  "#e8a88f",
  "#e8a077"
];

/** The swatch for one army, wrapping past the eighth. */
export const armyTone = (side: Color): string => ARMY_TONE[side % ARMY_TONE.length];
